import React from "react";

function ClosedRole({ chart_data }) {
  const data = Array.isArray(chart_data) ? chart_data : [];
  if (!data.length) {
    return <div className="text-muted">No Data Available</div>;
  }

  return (
    <>
      {data.map((emp) => (
        <div key={emp.id} className="card shadow-none mb-2">
         <div className="card-body">
  <div className="d-flex flex-column gap-1">

    {/* Title */}
    <h6 className="fs-16 fw-semibold mb-0">
      {emp.role_name.replace(/&amp;/g, "&")} - {emp.comapny_name}
    </h6>

    {/* Row 1 */}
    <div className="row align-items-center">
      <div className="col-6 text-start">
        <span className="fs-13 text-muted">
          Led by {emp.role_manager}
        </span>
      </div>

      <div className="col-6 text-end">
        <span className="fs-13 text-muted">
          Assigned To {emp.assigned_to}
        </span>
      </div>
    </div>

    {/* Row 2 */}
    <div className="row align-items-center">
      <div className="col-6 text-start">
        <span>{emp.candidate_name}</span>
      </div>

      <div className="col-6 text-end">
        <span className="d-inline-flex align-items-center">
          <i className="ti ti-calendar fs-16 me-2 text-primary"></i>
          {new Date(emp.doj).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </span>
      </div>
    </div>
    <span className="text-muted fs-13 mb-1">Allocated To: {emp.consultants}</span>
  </div>
</div>
        </div>
			))}
    </>
  );
}

export default ClosedRole;